

import React, { useEffect, useState } from 'react';
import './Profil.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCog } from '@fortawesome/free-solid-svg-icons';
import GetProCard from '../rightelements/GetProCard';
import FooterElements from '../rightelements/FooterElements';
import SocialElements from '../rightelements/SocialElements';
import bazeleconta from '../images/bazelecontaone.png';
import coinIcon from '../images/coin.png';
import boltIcon from '../images/bolt.png';
import firecorrect from '../images/firecorrect.png';
import userNeutralIcon from '../images/user_neutral.png';
import './reglaredimensiune.css';


const badges = [
  { name: 'Basic Profile', desc: 'Added bio to profile', progress: 0, total: 3 },
  { name: 'The Start', desc: 'Solved 3 coding problems', progress: 0, total: 5 },
  { name: 'Daily Coder', desc: 'Maintained a 3-day streak', progress: 0, total: 5 },
  { name: 'Basic Profile', desc: 'Added bio to profile', progress: 0, total: 3 },
  { name: 'The Start', desc: 'Solved 3 coding problems', progress: 0, total: 5 },
  { name: 'Daily Coder', desc: 'Maintained a 3-day streak', progress: 0, total: 5 },
  { name: 'Basic Profile', desc: 'Added bio to profile', progress: 0, total: 3 },
  { name: 'The Start', desc: 'Solved 3 coding problems', progress: 0, total: 5 },
  { name: 'Daily Coder', desc: 'Maintained a 3-day streak', progress: 0, total: 5 },
];

const apiUrl = process.env.REACT_APP_API_URL || '';

const toLocalISODate = (dateValue) => {
  const date = new Date(dateValue);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

const normalizeDbDay = (value) => String(value || '').slice(0, 10);

const getMondayOfCurrentWeek = (dateValue) => {
  const date = new Date(dateValue);
  date.setHours(0, 0, 0, 0);
  const dayOffsetFromMonday = (date.getDay() + 6) % 7;
  date.setDate(date.getDate() - dayOffsetFromMonday);
  return date;
};

const getWeekdayLabel = (dateValue) => {
  const labels = ['D', 'L', 'Ma', 'Mi', 'J', 'V', 'S'];
  const dayIndex = new Date(dateValue).getDay();
  return labels[dayIndex] || '';
};

const Profil = ({ onMenuSelect, onCogClick }) => {
  const [userData, setUserData] = useState(null);
  const [stats, setStats] = useState({ coins: 0, xp: 0 });
  const [weeklyRank, setWeeklyRank] = useState(null);
  const [weeklyPoints, setWeeklyPoints] = useState(0);
  const [isWeeklyRankLoading, setIsWeeklyRankLoading] = useState(true);
  const [courseProgress, setCourseProgress] = useState({ total: 0, completed: 0, percent: 0 });
  const [isCourseProgressLoading, setIsCourseProgressLoading] = useState(true);
  const [profileStreakDays, setProfileStreakDays] = useState([]);
  const [profileCurrentStreak, setProfileCurrentStreak] = useState(0);

  const currentDayIndex = (() => {
    const nativeDay = new Date().getDay();
    return nativeDay === 0 ? 6 : nativeDay - 1;
  })();

  useEffect(() => {
    const fetchStreakDays = async () => {
      try {
        const response = await fetch(`${apiUrl}/daily-lessons`, {
          method: 'GET',
          credentials: 'include',
        });

        if (!response.ok) {
          setProfileStreakDays([]);
          setProfileCurrentStreak(0);
          return;
        }

        const payload = await response.json();
        const xpByDay = new Map();

        const upsertDayXp = (row) => {
          const key = normalizeDbDay(row?.day);
          if (!key) return;
          xpByDay.set(key, Number(row?.daily_xp || 0));
        };

        upsertDayXp(payload?.today);
        (Array.isArray(payload?.history) ? payload.history : []).forEach(upsertDayXp);

        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const todayKey = toLocalISODate(today);

        let currentStreak = 0;
        const cursor = new Date(today);

        while (true) {
          const cursorKey = toLocalISODate(cursor);
          const xpForDay = Number(xpByDay.get(cursorKey) || 0);

          if (xpForDay > 0) {
            currentStreak += 1;
            cursor.setDate(cursor.getDate() - 1);
            continue;
          }

          break;
        }

        const streakStart = new Date(today);
        streakStart.setDate(today.getDate() - Math.max(currentStreak - 1, 0));
        streakStart.setHours(0, 0, 0, 0);

        setProfileCurrentStreak(currentStreak);

        const displayStart =
          currentStreak > 0
            ? new Date(streakStart)
            : getMondayOfCurrentWeek(today);

        const weekDays = Array.from({ length: 7 }).map((_, index) => {
          const date = new Date(displayStart);
          date.setDate(displayStart.getDate() + index);
          date.setHours(0, 0, 0, 0);

          const dayKey = toLocalISODate(date);
          const xp = Number(xpByDay.get(dayKey) || 0);

          return {
            key: dayKey,
            label: getWeekdayLabel(date),
            xp,
            isCurrentDay: dayKey === todayKey,
            isCompleted: xp > 0,
          };
        });

        setProfileStreakDays(weekDays);
      } catch (error) {
        setProfileStreakDays([]);
        setProfileCurrentStreak(0);
      }
    };

    fetchStreakDays();
  }, []);

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const res = await fetch(`${apiUrl}/user`, { credentials: 'include' });
        if (!res.ok) {
          setUserData(null);
          setStats({ coins: 0, xp: 0 });
          return;
        }

        const user = await res.json();
        setUserData(user);

        if (user?.user_id) {
          const statsRes = await fetch(`${apiUrl}/user/${user.user_id}/stats`, { credentials: 'include' });
          if (statsRes.ok) {
            const statsData = await statsRes.json();
            setStats({
              coins: Number(statsData?.coins ?? 0),
              xp: Number(statsData?.xp ?? 0),
            });
          } else {
            setStats({ coins: 0, xp: 0 });
          }

          try {
            const leaderboardRes = await fetch(`${apiUrl}/leaderboard?type=weekly`, {
              credentials: 'include',
            });

            if (leaderboardRes.ok) {
              const leaderboard = await leaderboardRes.json();
              const userId = Number(user.user_id);
              const currentUserEntry = Array.isArray(leaderboard)
                ? leaderboard.find((entry) => Number(entry?.user_id) === userId)
                : null;

              const points = Number(currentUserEntry?.points ?? 0);
              const position = Number(currentUserEntry?.position ?? 0);

              setWeeklyPoints(points);
              setWeeklyRank(points > 0 && position > 0 ? position : null);
            } else {
              setWeeklyPoints(0);
              setWeeklyRank(null);
            }
          } catch (error) {
            setWeeklyPoints(0);
            setWeeklyRank(null);
          } finally {
            setIsWeeklyRankLoading(false);
          }

          try {
            const [chaptersRes, progressRes] = await Promise.all([
              fetch(`${apiUrl}/chapters`, { credentials: 'include' }),
              fetch(`${apiUrl}/user/lesson-progress`, { credentials: 'include' }),
            ]);

            if (chaptersRes.ok && progressRes.ok) {
              const chaptersData = await chaptersRes.json();
              const lessonProgressData = await progressRes.json();

              const chapters = Array.isArray(chaptersData?.chapters) ? chaptersData.chapters : [];
              const totalLessons = chapters.reduce(
                (total, chapter) => total + (Array.isArray(chapter?.lessons) ? chapter.lessons.length : 0),
                0
              );

              const completedLessonKeys = new Set(
                (Array.isArray(lessonProgressData) ? lessonProgressData : []).map((entry) => `${entry.chapter_id}-${entry.lesson_id}`)
              );

              const completedLessons = chapters.reduce((count, chapter) => {
                const chapterId = chapter?.id;
                const lessons = Array.isArray(chapter?.lessons) ? chapter.lessons : [];

                return (
                  count +
                  lessons.reduce((chapterCount, lesson) => {
                    const key = `${chapterId}-${lesson.lesson}`;
                    return completedLessonKeys.has(key) ? chapterCount + 1 : chapterCount;
                  }, 0)
                );
              }, 0);

              const percent = totalLessons > 0
                ? Math.round((completedLessons / totalLessons) * 100)
                : 0;

              setCourseProgress({
                total: totalLessons,
                completed: completedLessons,
                percent,
              });
            } else {
              setCourseProgress({ total: 0, completed: 0, percent: 0 });
            }
          } catch (error) {
            setCourseProgress({ total: 0, completed: 0, percent: 0 });
          } finally {
            setIsCourseProgressLoading(false);
          }
        } else {
          setStats({ coins: 0, xp: 0 });
          setWeeklyPoints(0);
          setWeeklyRank(null);
          setIsWeeklyRankLoading(false);
          setCourseProgress({ total: 0, completed: 0, percent: 0 });
          setIsCourseProgressLoading(false);
        }
      } catch (err) {
        setUserData(null);
        setStats({ coins: 0, xp: 0 });
        setWeeklyPoints(0);
        setWeeklyRank(null);
        setIsWeeklyRankLoading(false);
        setCourseProgress({ total: 0, completed: 0, percent: 0 });
        setIsCourseProgressLoading(false);
      }
    };
    fetchUser();
  }, []);

  const formattedCoins = Number(stats.coins || 0).toLocaleString('ro-RO');
  const formattedXp = Number(stats.xp || 0).toLocaleString('ro-RO');

  return (

    <div className="componentsmenu-container-main">
      <div className="componentsmenu-left-blank"></div>
      <div className="profil-container">
      {/* Bara de sus cu Profile stanga si rotita dreapta */}
      <div className="profil-header-bar">
        <span className="profil-header-title">Profil</span>
        <span className="profil-header-cog" onClick={() => { if (onCogClick) { onCogClick(); } else if (onMenuSelect) { onMenuSelect('Setari'); } }} style={{cursor:'pointer'}}><FontAwesomeIcon icon={faCog} /></span>
      </div>
    

      {/* ...restul codului existent... */}
    <div className="profil-banner">
    

    <div className="profil-avatar-wrapper">
      <div className="profil-avatar-placeholder">
        {userData?.profile_picture ? (
          <img src={userData.profile_picture} alt="user" className="profil-avatar-img" />
        ) : (
          <img src={userNeutralIcon} alt="user" className="profil-avatar-img" />
        )}
      </div>
    </div>

    

    <div className="profil-level-box">
      <div className="profil-level-text">
          <h2 className="profil-username">{userData?.username || 'Utilizator'}</h2>
          <div className="profil-streak-summary">
            <img src={firecorrect} alt="streak" className="profil-streak-summary-icon" />
            <span>{profileCurrentStreak} {profileCurrentStreak === 1 ? 'zi consecutiva' : 'zile consecutive'}</span>
          </div>
      </div>

      <div className="profil-streak-days-row">
        {(profileStreakDays.length > 0 ? profileStreakDays : ['L', 'Ma', 'Mi', 'J', 'V', 'S', 'D'].map((label, index) => ({
          key: `fallback-${label}-${index}`,
          label,
          isCurrentDay: index === currentDayIndex,
          isCompleted: false,
        }))).map((dayItem) => (
          <div className="profil-streak-day-wrap" key={dayItem.key}>
            <span className={`profil-streak-day ${dayItem.isCurrentDay ? 'active' : ''} ${dayItem.isCompleted ? 'completed' : ''}`.trim()}>
              {dayItem.label}
            </span>

            {dayItem.isCurrentDay ? (
              <span className="profil-streak-indicator profil-streak-indicator-flame" aria-label="Ziua curenta">
                <img
                  src={firecorrect}
                  alt="flame"
                  className="profil-streak-indicator-flame-icon"
                />
              </span>
            ) : dayItem.isCompleted ? (
              <span className="profil-streak-indicator profil-streak-indicator-check" aria-label="Zi completata">
                ✓
              </span>
            ) : (
              <span className="profil-streak-indicator profil-streak-indicator-empty" aria-label="Zi necompletata">
                ○
              </span>
            )}
          </div>
        ))}
      </div>
     
   
    </div>

    
  </div>

      <div className="profil-course-progress-panel">
        <div className="profil-course-card-single">
          <div className="profil-course-card-header">
            <img src={bazeleconta} alt="Bazele contabilitatii" className="profil-course-card-image" />
            <div className="profil-course-card-name">Bazele contabilitatii</div>
          </div>

          <div className="profil-course-progress-summary">
            <div className="profil-course-progress-title">Progres curs</div>
            <div className="profil-course-progress-meta">
              {isCourseProgressLoading
                ? 'Se calculeaza progresul...'
                : `${courseProgress.completed} / ${courseProgress.total} lectii parcurse (${courseProgress.percent}%)`}
            </div>
            <div className="profil-course-progress-track" aria-hidden="true">
              <div
                className="profil-course-progress-fill"
                style={{ width: `${isCourseProgressLoading ? 0 : courseProgress.percent}%` }}
              />
            </div>
          </div>
        </div>
      </div>

      <div className="profil-main">

        <div className='user-stats-elements-secondsection'>
        
         
        
          <div className="profil-stats">
            <div className="profil-stat">
              <img src={coinIcon} alt="Monede" className="profil-stat-icon" />
              <span className="profil-stat-value">{formattedCoins}</span>
              <span className="profil-stat-label">Monede</span>
            </div>
            <div className="profil-stat">
              <img src={boltIcon} alt="XP" className="profil-stat-icon" />
              <span className="profil-stat-value profil-xp">{formattedXp}</span>
              <span className="profil-stat-label">XP</span>
            </div>
          </div>

          <div className="profil-weekly-rank-note" style={{ marginTop: '12px', fontSize: '14px', textAlign: 'center'}}>
            {isWeeklyRankLoading
              ? 'Se incarca pozitia din clasamentul saptamanal...'
              : weeklyRank
                ? `Locul tau in clasamentul saptamanal: #${weeklyRank} (${weeklyPoints} XP)`
                : 'Inca nu esti in clasamentul saptamanal. Fa XP din lectii ca sa intri in top!'}
          </div>

          <div className="profil-leaderboard-btn-wrap">
            <button
              type="button"
              className="profil-leaderboard-btn"
              onClick={() => {
                if (onMenuSelect) {
                  onMenuSelect('Clasament');
                }
              }}
            >
              <span>Vezi clasamentul</span>
            </button>
          </div>
        </div>
{/*

        <div className="profil-badges-box">
          <h3>Medalii</h3>
          <div className="profil-badges-list">
            {badges.map((badge, idx) => (
              <div className="profil-badge" key={idx}>
                <div className="profil-badge-icon">?</div>
                <div className="profil-badge-info">
                  <div className="profil-badge-title">{badge.name}</div>
                  <div className="profil-badge-desc">{badge.desc}</div>
                </div>
                <div className="profil-badge-progress">{badge.progress}/{badge.total}</div>
              </div>
            ))}
          </div>
        </div>
        */}
      </div>
 

      </div>
      <div className="right-elements-componentsmenu-profil">
        <GetProCard />
           <FooterElements />
      <SocialElements />
      </div>
    </div>



  );
}

export default Profil;
